import { Link } from "react-router-dom";
import { getByType } from "@/utils/movie";

const ENTRIES = [
  {
    key: "movie" as const,
    label: "电影",
    desc: "院线新片 · 高分佳作 · 类型大片",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20with%20rows%20of%20seats%20and%20a%20glowing%20blank%20screen%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grading%2C%20dramatic%20lighting%2C%20film%20grain%2C%20no%20text&width=800&height=460&seq=qx-cat-movie&orientation=landscape",
    icon: "ri-film-line",
  },
  {
    key: "tv" as const,
    label: "电视剧",
    desc: "热播剧集 · 全集在线 · 追剧不停",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20cinematic%20living%20room%20at%20night%20with%20a%20glowing%20tv%20screen%20and%20warm%20lamplight%2C%20deep%20navy%20and%20orange%20color%20grading%2C%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=800&height=460&seq=qx-cat-tv&orientation=landscape",
    icon: "ri-live-line",
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
      {ENTRIES.map((entry) => {
        const count = getByType(entry.key).length;
        return (
          <Link
            key={entry.key}
            to={`/category/${entry.key}`}
            className="group relative block h-44 overflow-hidden rounded-xl md:h-52 cursor-pointer"
          >
            <img
              src={entry.image}
              alt={`秋霞网${entry.label}资源`}
              title={`秋霞网${entry.label}频道`}
              className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/95 via-secondary-950/70 to-secondary-950/20" />
            <div className="absolute inset-0 flex flex-col justify-center px-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
                <i className={`${entry.icon} text-2xl`} />
              </span>
              <h3 className="mt-3 font-heading text-2xl font-semibold text-foreground-950">
                {entry.label}
              </h3>
              <p className="mt-1 text-sm text-foreground-500">{entry.desc}</p>
              <span className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
                共收录 {count}+ 部资源
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}